import React from 'react';
import { Layout } from 'antd';
import { useLocation } from 'react-router-dom';
import { AppHeader } from './app-header';
import { ConnectModal } from './connect-modal';
import { HomePage } from '../pages/home-page';
import { ConnectionsPage } from '../pages/connections-page';
import { RankingPage } from '../pages/ranking-page';
import { MisPublicacionesPage } from '../pages/mis-publicaciones-page';
import { AccessPage } from '../pages/access-page';
import { SettingsPage } from '../pages/settings-page';
import { AdminPage } from '../pages/admin-page';
import { AdminGuard } from './admin-guard';
import { useSocialContext } from '../context/social';
import { PaymentProfileProvider } from '../context/payment-profile';
import { PaymentDataGate } from './payment-data-gate';

const { Content, Footer } = Layout;

// Rutas accesibles sin tener cuenta conectada. SOLO las legales (las exige la
// review de TikTok). Todo lo demás manda al deslogueado a AccessPage (login
// TikTok) — pedido de Agustín 2026-07-07: "un usuario sin estar logueado
// siempre que se pueda debería ser enviado a la página inicial del acceso".
// (/ranking era público desde un wip de abril; se saca a propósito.)
const PUBLIC_PATHS = ['/privacy', '/terms', '/data-deletion'];

export const AppLayout: React.FC = () => {
  const [connectModalOpen, setConnectModalOpen] = React.useState(false);
  const location = useLocation();
  const { isAuthenticated, loading, accounts } = useSocialContext();
  const contentRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    contentRef.current?.scrollTo(0, 0);
  }, [location.pathname]);

  const isPublic = PUBLIC_PATHS.some(p => location.pathname.startsWith(p));

  // Mostrar AccessPage si:
  // - No hay JWT (nunca estuvo logueado), o
  // - Tenía JWT pero después de cargar no tiene ninguna cuenta (JWT huérfano — p.ej. tras restore de DB)
  const jwtOrphaned = isAuthenticated && !loading && accounts.length === 0;
  if ((!isAuthenticated || jwtOrphaned) && !isPublic) {
    return <AccessPage />;
  }

  const renderPage = () => {
    // Admin (gated). Solo queda el panel operativo de staff (DB browser +
    // Excepciones + triggers). El ranking de amplificadores y el detalle por
    // usuario se movieron a Brands (vista por marca) — /admin/ranking y
    // /admin/posts/:userId redirigen a Brands desde App.tsx.
    if (location.pathname.startsWith('/admin')) {
      return <AdminGuard><AdminPage /></AdminGuard>;
    }
    if (location.pathname.startsWith('/connections')) {
      return <ConnectionsPage onConnectClick={() => setConnectModalOpen(true)} />;
    }
    if (location.pathname.startsWith('/ranking')) {
      return <RankingPage />;
    }
    if (location.pathname.startsWith('/mis-publicaciones')) {
      return <MisPublicacionesPage />;
    }
    if (location.pathname.startsWith('/settings')) {
      return <SettingsPage />;
    }
    return <HomePage />;
  };

  return (
    <PaymentProfileProvider>
    <Layout style={{ minHeight: '100vh', background: '#f8f9fa' }}>
      <AppHeader onConnectClick={() => setConnectModalOpen(true)} />
      <PaymentDataGate />
      <Content ref={contentRef} style={{ overflow: 'auto', background: '#f8f9fa', padding: 0 }}>
        {/* key on the path forces React to fully remount the page subtree on
            navigation. Belt-and-suspenders since AppHeader.handleNav also does
            full-page reloads. */}
        <div key={location.pathname}>{renderPage()}</div>
      </Content>
      <ConnectModal open={connectModalOpen} onClose={() => setConnectModalOpen(false)} />
      <Footer style={{ textAlign: 'center', background: '#f8f9fa', padding: '12px 24px', borderTop: '1px solid rgba(0,0,0,0.06)' }}>
        <span style={{ fontSize: 12, color: '#9ca3af' }}>
          <a href='/privacy' style={{ color: '#9ca3af' }}>Política de privacidad</a>
          {' · '}
          <a href='/terms' style={{ color: '#9ca3af' }}>Términos de uso</a>
        </span>
      </Footer>
    </Layout>
    </PaymentProfileProvider>
  );
};
